import {useParams} from 'react-router-dom';
import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {SiteDocumentTitle} from 'src/pages/Modules/Clients/shared/siteHelpers';
import {SiteForm} from 'src/pages/Modules/Clients/shared/SiteForm';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

export const SiteEditPage = () => {
  useSetDocumentTitle(SiteDocumentTitle);
  const {siteId} = useParams();

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.Clients}>
      <SiteForm id={Number(siteId)} mode="edit" />
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.SitesEdit(':siteId'),
  element: <SiteEditPage />,
  module: ModuleEnum.Clients,
  operation: PermissionOperationEnum.Update,
  isPrivate: true,
});
